import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./administrationNavbar.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Cookies from "js-cookie";

import { RiGalleryFill } from "react-icons/ri";
import { FaCalendarAlt, FaHome } from "react-icons/fa";
import { GrUserAdmin } from "react-icons/gr";
import { MdEmail } from "react-icons/md";

export default function AdministrationNavbar({onItemClick}) {
    const navigate = useNavigate();

    const [selectedItem, setSelectedItem] = useState(4);

    useEffect(() => {
        document.title = "DJ - EMAN"
    }, []);

    return (
        <div className="administrationNavbar">
            <div className="navbar">
                <div className={`containerItem ${selectedItem == 1 ? "selectedItem" : ""}`} onClick={() => {setSelectedItem(1); onItemClick?.(1);}}>
                    <MdEmail className="icon" />
                </div>
                <div className={`containerItem ${selectedItem == 2 ? "selectedItem" : ""}`} onClick={() => {setSelectedItem(2); onItemClick?.(2);}}>
                    <RiGalleryFill className="icon" />
                </div>
                <div className={`containerItem ${selectedItem == 3 ? "selectedItem" : ""}`} onClick={() => {setSelectedItem(3); onItemClick?.(3);}}>
                    <FaCalendarAlt className="icon" />
                </div>
                <div className={`containerItem ${selectedItem == 4 ? "selectedItem" : ""}`} onClick={() => {setSelectedItem(4); onItemClick?.(4);}}>
                    <GrUserAdmin className="icon" />
                </div>
                <div className={`containerItem ${selectedItem == 5 ? "selectedItem" : ""}`} onClick={() => navigate("/musicrequesthome")}>
                    <FaHome className="icon" />
                </div>
            </div>
        </div>
    )
}
